<template>
  <v-container>
    <div class="d-flex justify-center align-center">
      <v-progress-circular
              v-if="!showDialog"
              indeterminate
              color="accent"
      ></v-progress-circular>
      <v-dialog v-model="showDialog"
                :scrim="false"
                persistent
                width="300">
        <v-card
                color="primary"
                theme="dark"
        >
          <v-card-text>
            {{ message ? message : 'Loading...'}}
            <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0 mt-1"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
  export default {
    name: "Loading",
    props: {
      message: {
        type: String,
        required: false
      },
      dialog: {
        type: Boolean,
        required: false,
        default: false
      },
      loading: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    methods: {
    },
    data () {
      return {
        showDialog: this.dialog
      }
    },
    watch: {
      dialog(val) {
        this.showDialog = val
      },
      loading() {
        this.showDialog = this.$props.dialog
      }
    }
  }
</script>

<style scoped>

</style>